import React from "react";
import "../../css/home/promotion.css";


function Promotion({Header, Footer, Footer2}) {
    return (
        <div className="Promotion">
            <h2 className="Promotion">
                {Header}
            </h2>
            <p className="Promotion">
                {Footer}
            </p>
            <p className="Promotion">
                {Footer2}
            </p>
        </div>
    )
}


export default Promotion;